export default __webpack_public_path__ + "static/media/Nosotros_imagen2_768.ad56326e.jpg";